import * as React from 'react';
import LocaleContext from './context';
import defaultLocaleData from './en_US';

var useLocale = function useLocale(componentName, defaultLocale) {
  var fullLocale = React.useContext(LocaleContext);
  var getLocale = React.useMemo(function () {
    var _a;

    var locale = defaultLocale || defaultLocaleData[componentName];
    var localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  var getLocaleCode = React.useMemo(function () {
    var localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale; // Had use LocaleProvide but didn't set locale

    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return defaultLocaleData.locale;
    }

    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};

export default useLocale;